import axios from "axios";
import { getSessionData, updateStoredSession } from "../utils/sessionAuth";
import qs from "qs";

const { REACT_APP_MY_ENV } = process.env;

const axiosInstance = axios.create({
  baseURL: REACT_APP_MY_ENV,
});

function getAuthorizationHeader() {
  return (
    "Bearer " +
    JSON.parse(
      sessionStorage.hasOwnProperty("token_store")
        ? sessionStorage.getItem("token_store")
        : JSON.stringify({ token: "empty" })
    ).token
  );
}

export function runMediaMacro(mediaId) {
  return axiosInstance({
    method: "post",
    url: `/macro/media/${mediaId}/run`,
    headers: {
      Authorization: getAuthorizationHeader(),
    },
  });
}

export function savePhotoCampaign(values) {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "post",
      url: "/mediaAd/photo",
      headers: {
        post: {
          Authorization:
            "Bearer " +
            JSON.parse(
              sessionStorage.hasOwnProperty("token_store")
                ? sessionStorage.getItem("token_store")
                : JSON.stringify({ token: "empty" })
            ).token,
          "Content-Type": "multipart/form-data",
        },
      },
      data: values,
    })
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          //  window.location.href = "http://localhost:3000/campaigns";
          resolve(response);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function editAdCampaign(values, id) {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "put",
      url: "/mediaAd/" + id,
      headers: {
        put: {
          Authorization:
            "Bearer " +
            JSON.parse(
              sessionStorage.hasOwnProperty("token_store")
                ? sessionStorage.getItem("token_store")
                : JSON.stringify({ token: "empty" })
            ).token,
          "Content-Type": "multipart/form-data",
        },
      },
      data: values,
    })
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          // window.location.href = "http://localhost:3000/campaigns";
          resolve(response);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function saveVideoCampaign(values) {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "post",
      url: "/mediaAd/video",
      headers: {
        post: {
          Authorization:
            "Bearer " +
            JSON.parse(
              sessionStorage.hasOwnProperty("token_store")
                ? sessionStorage.getItem("token_store")
                : JSON.stringify({ token: "empty" })
            ).token,
          "Content-Type": "multipart/form-data",
        },
      },
      data: values,
    })
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          // window.location.href = "http://localhost:3000/campaigns";

          resolve(response);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function saveGifCampaign(values) {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "post",
      url: "/mediaAd/gif",
      headers: {
        post: {
          Authorization:
            "Bearer " +
            JSON.parse(
              sessionStorage.hasOwnProperty("token_store")
                ? sessionStorage.getItem("token_store")
                : JSON.stringify({ token: "empty" })
            ).token,
          "Content-Type": "multipart/form-data",
        },
      },
      data: values,
    })
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          // window.location.href = "http://localhost:3000/campaigns";
          resolve(response);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function saveSurveyCampaign(values) {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "post",
      url: "/mediaAd/survey",
      headers: {
        post: {
          Authorization:
            "Bearer " +
            JSON.parse(
              sessionStorage.hasOwnProperty("token_store")
                ? sessionStorage.getItem("token_store")
                : JSON.stringify({ token: "empty" })
            ).token,
          "Content-Type": "multipart/form-data",
        },
      },
      data: values,
    })
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          resolve(response);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function loadDashboardAdsData_DataUsage(id, endDate, startDate) {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "get",
      url: "/mediaAd/" + id + "/dataUsage",
      params: {
        startingDate: startDate,
        endingDate: endDate,
      },
      headers: {
        get: {
          Authorization:
            "Bearer " +
            JSON.parse(
              sessionStorage.hasOwnProperty("token_store")
                ? sessionStorage.getItem("token_store")
                : JSON.stringify({ token: "empty" })
            ).token,
          "Content-Type": "multipart/form-data",
        },
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function loadDashboardAdsData_UserUnique(id, endDate, startDate) {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "get",
      url: "/mediaAd/" + id + "/newUsers",
      params: {
        startingDate: startDate,
        endingDate: endDate,
      },
      headers: {
        get: {
          Authorization:
            "Bearer " +
            JSON.parse(
              sessionStorage.hasOwnProperty("token_store")
                ? sessionStorage.getItem("token_store")
                : JSON.stringify({ token: "empty" })
            ).token,
          "Content-Type": "multipart/form-data",
        },
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function loadDashboardAdsData_UserConcurrent(id, endDate, startDate) {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "get",
      url: "/mediaAd/" + id + "/concurrentUsers",
      params: {
        startingDate: startDate,
        endingDate: endDate,
      },
      headers: {
        get: {
          Authorization:
            "Bearer " +
            JSON.parse(
              sessionStorage.hasOwnProperty("token_store")
                ? sessionStorage.getItem("token_store")
                : JSON.stringify({ token: "empty" })
            ).token,
          "Content-Type": "multipart/form-data",
        },
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function loadDashboardAdsData_ConexionesByDate(id, endDate, startDate) {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "get",
      url: "/mediaAd/" + id + "/usedConnections",
      params: {
        startingDate: startDate,
        endingDate: endDate,
      },
      headers: {
        get: {
          Authorization:
            "Bearer " +
            JSON.parse(
              sessionStorage.hasOwnProperty("token_store")
                ? sessionStorage.getItem("token_store")
                : JSON.stringify({ token: "empty" })
            ).token,
          "Content-Type": "multipart/form-data",
        },
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function loadMediaAds(mediaStatus) {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "get",
      url: "/mediaAd/",
      params:
        mediaStatus === undefined || mediaStatus === null
          ? undefined
          : { mediaStatus },
      headers: {
        get: {
          Authorization:
            "Bearer " +
            JSON.parse(
              sessionStorage.hasOwnProperty("token_store")
                ? sessionStorage.getItem("token_store")
                : JSON.stringify({ token: "empty" })
            ).token,
        },
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function load_ZoneMediaAd(zoneList, campaignId) {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "get",
      url: "/mediaAd/zone",
      headers: {
        get: {
          Authorization:
            "Bearer " +
            JSON.parse(
              sessionStorage.hasOwnProperty("token_store")
                ? sessionStorage.getItem("token_store")
                : JSON.stringify({ token: "empty" })
            ).token,
        },
      },
      params: {
        zoneIdList: zoneList,
        campaignId: campaignId,
      },
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function load_CampaignInfo(endDate, startDate, campaignId) {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "get",
      url:
        campaignId === "all"
          ? "/mediaAd/zone/all"
          : "/mediaAd/zone/campaign/" + campaignId,
      headers: {
        get: {
          Authorization:
            "Bearer " +
            JSON.parse(
              sessionStorage.hasOwnProperty("token_store")
                ? sessionStorage.getItem("token_store")
                : JSON.stringify({ token: "empty" })
            ).token,
        },
      },
      params: {
        startingDate: startDate,
        endingDate: endDate,
      },
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function load_mediaAdInfo(id, endDate, startDate) {
  console.log(id);
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "get",
      url: "/mediaAd/zone/campaign/ad/" + id,

      headers: {
        get: {
          Authorization:
            "Bearer " +
            JSON.parse(
              sessionStorage.hasOwnProperty("token_store")
                ? sessionStorage.getItem("token_store")
                : JSON.stringify({ token: "empty" })
            ).token,
        },
      },
      params: {
        startingDate: startDate,
        endingDate: endDate,
      },
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function load_MediaAdInfoMap(mediaAdId, zoneList, startDate, endDate) {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "get",
      url: "/mediaAd/zone/campaign/ad/" + mediaAdId,
      headers: {
        get: {
          Authorization:
            "Bearer " +
            JSON.parse(
              sessionStorage.hasOwnProperty("token_store")
                ? sessionStorage.getItem("token_store")
                : JSON.stringify({ token: "empty" })
            ).token,
        },
      },
      params: {
        zones: zoneList,
        startingDate: startDate,
        endingDate: endDate,
      },
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function load_CampaignInfoMap(campaignId, zoneList, startDate, endDate) {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "get",
      url: "/mediaAd/zone/campaign/" + campaignId,
      headers: {
        get: {
          Authorization:
            "Bearer " +
            JSON.parse(
              sessionStorage.hasOwnProperty("token_store")
                ? sessionStorage.getItem("token_store")
                : JSON.stringify({ token: "empty" })
            ).token,
        },
      },
      params: {
        zones: zoneList,
        startingDate: startDate,
        endingDate: endDate,
      },
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function deleteMediaAd(id) {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "delete",
      url: "/mediaAd/" + id,
      headers: {
        delete: {
          Authorization:
            "Bearer " +
            JSON.parse(
              sessionStorage.hasOwnProperty("token_store")
                ? sessionStorage.getItem("token_store")
                : JSON.stringify({ token: "empty" })
            ).token,
        },
      },
    })
      .then((response) => {
        if (response.status === 200 || response.status === 202) {
          resolve(response);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function reactivateMediaAd(id) {
  return axiosInstance({
    method: "put",
    url: "/mediaAd/" + id + "/reactivate",
    headers: {
      put: {
        Authorization: getAuthorizationHeader(),
      },
    },
  });
}

export function updateMediaAdExpiryDate(id, expiryDate) {
  return new Promise((resolve, reject) => {
    const normalizedExpiryDate = expiryDate || "";

    axiosInstance({
      method: "put",
      url:
        "/mediaAd/media-ads/" +
        id +
        "/expiry-date?expiryDate=" +
        encodeURIComponent(normalizedExpiryDate),
      headers: {
        put: {
          Authorization:
            "Bearer " +
            JSON.parse(
              sessionStorage.hasOwnProperty("token_store")
                ? sessionStorage.getItem("token_store")
                : JSON.stringify({ token: "empty" })
            ).token,
        },
      },
    })
      .then((response) => {
        if (response.status === 200 || response.status === 202) {
          resolve(response);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function updateBudget() {
  const localStg = getSessionData();

  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "get",
      url: "/client/info",
      headers: {
        get: {
          Authorization:
            "Bearer " +
            JSON.parse(
              sessionStorage.hasOwnProperty("token_store")
                ? sessionStorage.getItem("token_store")
                : JSON.stringify({ token: "empty" })
            ).token,
        },
      },
    })
      .then((response) => {
        if (response.status === 200 || response.status === 202) {
          if (localStg) {
            updateStoredSession({ balance: response.data.balance });
          }

          resolve(response.data);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function mediaAdsActiveDashbboard() {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "get",
      url: "/mediaAd/?mediaStatus=3",
      headers: {
        get: {
          Authorization:
            "Bearer " +
            JSON.parse(
              sessionStorage.hasOwnProperty("token_store")
                ? sessionStorage.getItem("token_store")
                : JSON.stringify({ token: "empty" })
            ).token,
        },
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function mediaAdsBudgetDashboard() {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "get",
      url: "/mediaAd/budget?mediaAdStatus=3",
      headers: {
        get: {
          Authorization:
            "Bearer " +
            JSON.parse(
              sessionStorage.hasOwnProperty("token_store")
                ? sessionStorage.getItem("token_store")
                : JSON.stringify({ token: "empty" })
            ).token,
        },
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data.budget);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function mediaAdsSuccessfulConnectionDashboard(
  endDate,
  startDate,
  campaignId
) {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "get",
      url:
        campaignId === "all"
          ? "/mediaAd/usedConnections?mediaAdStatus=3"
          : "/mediaAd/usedConnections/" + campaignId + "?mediaAdStatus=3",
      params: {
        startingDate: startDate,
        endingDate: endDate,
      },
      headers: {
        get: {
          Authorization:
            "Bearer " +
            JSON.parse(
              sessionStorage.hasOwnProperty("token_store")
                ? sessionStorage.getItem("token_store")
                : JSON.stringify({ token: "empty" })
            ).token,
        },
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function getSurveyAnswerTypes() {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "get",
      url: "/survey/answer/type",
      headers: {
        get: {
          Authorization:
            "Bearer " +
            JSON.parse(
              sessionStorage.hasOwnProperty("token_store")
                ? sessionStorage.getItem("token_store")
                : JSON.stringify({ token: "empty" })
            ).token,
        },
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function liveConnectionsDashbboard() {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "get",
      url: "/mediaAd/liveConnections",
      headers: {
        get: {
          Authorization:
            "Bearer " +
            JSON.parse(
              sessionStorage.hasOwnProperty("token_store")
                ? sessionStorage.getItem("token_store")
                : JSON.stringify({ token: "empty" })
            ).token,
        },
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
